import moment from 'moment';

import {
  StatusColor,
  StatusText,
  type AdaptedDay,
  type AdaptedRecord,
  type AdaptedService,
} from '@app/components/VisitsHistory/types';
import type { NRecords } from '@app/types';

import 'moment/locale/ru';

export function adaptVisitsData(
  recordsGroupedByDates: NRecords.VisitHistoryRecords
): AdaptedDay[] {
  const days = Object.keys(recordsGroupedByDates)
    .sort((a, b) => moment(b).valueOf() - moment(a).valueOf())
    .map((dateKey) => {
      const rawRecords = recordsGroupedByDates[dateKey];
      const adaptedRecords: AdaptedRecord[] = rawRecords.map(
        ({ Employee, Status, Services, TimeS, RecordId, Comment }) => {
          const timeS = moment(TimeS);
          const performer = Employee || 'Без исполнителя';
          const statusColor = StatusColor[Status as keyof typeof StatusColor];
          const statusText = StatusText[Status as keyof typeof StatusText];

          const services: AdaptedService[] = (Services || [])?.map(
            ({ Service, Cost, Discount, CostWithDiscount }) => ({
              name: Service || 'Без названия',
              cost: Cost ?? 0,
              discount: Discount ?? 0,
              costWithDiscount: CostWithDiscount ?? 0,
            })
          );

          const totalPaid =
            Services?.reduce((acc, { Paid }) => acc + (Paid ?? 0), 0) ?? 0;

          return {
            id: RecordId,
            date: moment(dateKey).format('D MMMM YYYY'),
            time: timeS.format('HH:mm'),
            performer,
            statusColor,
            statusText,
            services,
            paid: totalPaid,
            comment: Comment?.trim() ?? '',
          };
        }
      );

      return {
        date: moment(dateKey).format('D MMMM YYYY'),
        records: adaptedRecords,
      };
    });

  return days;
}
